import _ from 'lodash';

const TELCO_PHONE_LOOKUP = new Map([
  [
    'Viettel',
    [
      '0162',
      '0163',
      '0164',
      '0165',
      '0166',
      '0167',
      '0168',
      '0169',
      '086',
      '096',
      '097',
      '098',
      '032',
      '033',
      '034',
      '035',
      '036',
      '037',
      '038',
      '039'],
  ],
  [
    'Mobifone',
    [
      '0120',
      '0121',
      '0122',
      '0126',
      '0128',
      '090',
      '093',
      '089',
      '070',
      '079',
      '077',
      '076',
      '078'],
  ],
  [
    'Vinaphone',
    [
      '0123',
      '0124',
      '0125',
      '0127',
      '0129',
      '091',
      '094',
      '088',
      '083',
      '084',
      '085',
      '081',
      '082'],
  ],
  [
    'Vietnamobile',
    ['0186', '0188', '092', '056', '058'],
  ],
  [
    'Beeline',
    ['0199', '099', '159'],
  ],
]);

export default class PhoneUtils {

  static findTelco = (phone) => {
    if (_.isEmpty(phone)) {
      return;
    }

    for (let entry of TELCO_PHONE_LOOKUP.entries()) {
      const prefixes = entry[1];
      const index = _.findIndex(prefixes,
        prefix => _.startsWith(phone, prefix));
      if (index >= 0) {
        return entry[0];
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/utils/PhoneUtils.js